import axios from 'axios';
import { httpClient } from '../../../../Common/api/http_client';
import oneRequest from '../../../../Common/api/api-debounce';

/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createItem(data) {
  return httpClient.post('/merchant/items', data);
}

/**
 *
 * @param page
 * @param limit
 * @param query
 * @param filter
 * @param direction
 * @returns {Promise<AxiosResponse<any>>}
 */
export function fetchAllProducts(page, limit, query, filter, direction) {
  const config = {
    method: 'get',
    url: `/merchant/items?query=${query}&limit=${limit}&page=${page}&filter=${filter}&direction=${direction}`,
    baseURL: process.env.VUE_APP_ECOMMERCE_BASE_API,
  };

  return oneRequest(config)
    .then(response => response)
    .catch((error) => {
      if (axios.isCancel(error)) {
        console.log('request canceled', error);
      }
    });
}

/**
 *
 * @param productId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getProduct(productId) {
  return httpClient.get(`/merchant/items/${productId}`);
}

/**
 *
 * @param productId
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateProduct(productId, data) {
  return httpClient.put(`/merchant/items/${productId}`, data);
}

/**
 *
 * @param productId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteProduct(productId) {
  return httpClient.delete(`/merchant/items/${productId}`);
}

/**
 *
 * @param productId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateOrCreateItemCatalog(productId, data) {
  return httpClient.put(`/merchant/items/${productId}/catalogs`, data);
}

/**
 *
 * @param catalogId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemCatalog(catalogId) {
  return httpClient.delete(`/merchant/items_catalogs/${catalogId}`);
}

/**
 *
 * @param productId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateOrCreateItemOutlet(productId, data) {
  return httpClient.put(`/merchant/items/${productId}/outlets`, data);
}

/**
 *
 * @param outletId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemOutlet(outletId) {
  return httpClient.delete(`/merchant/items_outlets/${outletId}`);
}

/**
 *
 * @param productId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateOrCreateItemAttribute(productId, data) {
  return httpClient.put(`/merchant/items/${productId}/attributes`, data);
}

/**
 *
 * @param attributeId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemAttribute(attributeId) {
  return httpClient.delete(`/merchant/items_attributes/${attributeId}`);
}

/**
 *
 * @param productId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateOrCreateItemAvailableDay(productId, data) {
  return httpClient.put(`/merchant/items/${productId}/available`, data);
}

/**
 *
 * @param availableId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemAvailableDay(availableId) {
  return httpClient.delete(`/merchant/items_available/${availableId}`);
}

/**
 *
 * @param configId
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function updateItemConfig(configId, data) {
  return httpClient.put(`/merchant/configs/${configId}`, data);
}

/**
 *
 * @param configId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemConfig(configId) {
  return httpClient.delete(`/merchant/configs/${configId}`);
}

/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function fetchPluckedProducts() {
  return httpClient.get('/merchant/plucked-items');
}

/**
 * @param imageId
 * @returns {Promise<AxiosResponse<any>>}
 */
export function deleteItemImage(imageId) {
  return httpClient.delete(`/images/${imageId}`);
}

/**
 * @returns {Promise<AxiosResponse<any>>}
 * @param formData
 */
export function bulkDiscount(formData) {
  return httpClient.put('/merchant/item_discount', formData);
}

/**
 *
 * @returns {Promise<AxiosResponse<any>>}
 */
export function getCsvUpload() {
  return httpClient.get('/merchant/csv-uploads');
}
